export default function AttachStatementDocumentController(
  $rootScope,
  $scope,
  $q,
  $filter,
  $timeout,
  ssDialogService,
  loaderService,
  alerts,
  userService,
  ecatDataService
) {
  const vm = this;

  // Set Default Values
  vm.canExpand = vm.status !== 'No Document Added';
  vm.isExpanded = false;
  vm.loading = false;
  vm.canDownloadDocument = userService.getUserPermission('displayDOCDownloadDocumentLink');
  vm.canEditDocument = userService.getUserPermission('displayDOCEditDocumentLink');
  vm.canDeleteDocument = userService.getUserPermission('displayDOCDeleteDocumentLink');

  // Attach Event Handlers
  vm.handleAttachDocument = _handleAttachDocument;

  function _handleAttachDocument() {
    const dfdSave = $q.defer();

    if (vm.document.attached) {
      ecatDataService.attachCRIStatementDocument(vm.assessmentId, vm.criStatementId, vm.document.documentId, vm.document.name).then(response => {
        if (!response.data) {
          alerts.error('Error occurred while attaching the Document.');
          dfdSave.reject();
        } else {
          alerts.success(`Document ${vm.document.name} has been attached successfully.`);
          vm.document.CRIStatementDocumentId = response.data.CRIStatementDocumentId;
          $rootScope.$broadcast('refreshCRIStatementDocuments', { criStatementId: vm.criStatementId });
          dfdSave.resolve();
        }
      });
    } else {
      ecatDataService.detachCRIStatementDocument(vm.document.CRIStatementDocumentId).then((response) => {
        if (!response.status === 200) {
          alerts.error('Error occurred while detaching the Document.');
          dfdSave.reject();
        } else {
          alerts.success(`Document ${vm.document.name} has been detached successfully.`);
          vm.document.CRIStatementDocumentId = null;
          $rootScope.$broadcast('refreshCRIStatementDocuments', { criStatementId: vm.criStatementId });
          dfdSave.resolve();
        }
      });
    }
  }
}

AttachStatementDocumentController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  '$filter',
  '$timeout',
  'ssDialogService',
  'loaderService',
  'alerts',
  'userService',
  'ecatDataService'
];
